import { useState, useEffect } from 'react';
import {
  DetailInvestPay,
  Recordatory,
  ExtraInfo,
  ModalCancelInvestment,
  InvestInfo
} from './cancelInvestment.styles';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { environment, url } from 'src/environments';
import { Button } from 'src/utilities/UILibrary/UI/Button/Button';
import createNumber from 'src/functions/createNumber';

export default function CancelInvestmentInvestor({
  showModalCancelInvest,
  listBids,
  setCancelInvestmentInvestor
}) {
  const user = useSelector((state) => state.user.currentUser);
  const personalInformation = useSelector((state) => state.profile.personalInformation);
  const dispatch = useDispatch();
  const [detailInvestPay, setDetailInvestPay] = useState(showModalCancelInvest);
  const [showInput, setShowInput] = useState(false);
  const [messageId, setMessageId] = useState();
  const [otp, setOtp] = useState('');
  //Para STP
  const amount = listBids?.compromisoInversion;
  const company = personalInformation?.data?.getInvestor?.companyInformation;
  const personal = personalInformation?.data?.getInvestor?.personalInformation;
  const account = personalInformation?.data?.getInvestor?.STP;
  const finspheraAccount = process.env.REACT_APP_STPACCOUNT_FINSPHERA;
  useEffect(() => {
    setDetailInvestPay(showModalCancelInvest);
  }, [showModalCancelInvest]);

  const closeModal = () => {
    setDetailInvestPay(false);
    setCancelInvestmentInvestor(false);
  };
  const handleSendEmail = () => {
    const input = {
      id: user.id,
      typeOfUser: 'investor',
      typeMessage: 'regretMoney',
      email: user.email,
      timestamp: Date.now()
    };
    axios
      .post(`${url}/${environment}/admin/send-otp-to-email`, input)
      .then((response) => {
        const parsedBody = JSON.parse(response.data.body);
        setMessageId(parsedBody.messageId);
        setShowInput(true);
      })
      .catch((error) => {
        console.error(error);
      });
    setShowInput(true);
  };

  const handleOtpSubmit = async () => {
    const input = {
      id: user.id,
      messageId: messageId,
      code: otp,
      timestamp: Date.now(),
      typeOfUser: 'investor'
    };
    try {
      const validationCode = await axios.post(
        `${url}/${environment}/admin/email/validate-otp`,
        input
      );
      const parsedBody = JSON.parse(validationCode.data.body);
      if (!parsedBody.isVerified) {
        alert('Código incorrecto');
        return;
      }
      const resources = {
        clientId: user.id,
        amount: listBids?.compromisoInversion,
        campaignId: listBids?.campaign?.id,
        type: 'cancelacion',
        investmentId: listBids?.id
      };
      try {
        await axios.post(
          `${process.env.REACT_APP_STPURL_FINSPHERA}/update-investor-balances-in-STP`,
          resources
        );
      } catch (error) {
        console.error(error);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const isExpired = listBids?.campaign?.isExpired === '1';
  // const isSigned = listBids?.campaign?.isPromissoryNoteSigned === '1' ? 'Firmado' : 'No firmado';
  // const isSuccessful = listBids?.campaign?.isSuccessful === '0' ? 'Incompleta' : 'Exitosa';

  // function formatDate(dateString) {
  //   const date = new Date(dateString);
  //   const year = date.getFullYear();
  //   const month = (date.getMonth() + 1).toString().padStart(2, '0');
  //   const day = date.getDate().toString().padStart(2, '0');
  //   return `${year}-${month}-${day}`;
  // }

  function formatCurrency(amount) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  }

  return (
    <ModalCancelInvestment showModalCancelInvest={showModalCancelInvest}>
      <div>
        <div>
          <h3>Cancelar inversión</h3>
          <figure onClick={closeModal}>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
              alt="icono para cerrar la ventana"
            />
          </figure>
        </div>
        <DetailInvestPay isExpired={isExpired}>
          <h3>Estás a punto de cancelar tu inversión:</h3>
          <InvestInfo>
            <div>
              <h4>ID inversión:</h4>
              <p>{listBids?.id}</p>
            </div>
            <div>
              <h4>Porcentaje del total invertido:</h4>
              <p>
                {listBids?.porcentajeGananciaInteres * 100
                  ? listBids?.porcentajeGananciaInteres * 100
                  : '-'}
                %
              </p>
            </div>
            <div>
              <h4>Monto invertido:</h4>
              <p>
                {formatCurrency(listBids?.compromisoInversion)
                  ? formatCurrency(listBids?.compromisoInversion)
                  : '-'}
              </p>
            </div>
            <div>
              <h4>Monto total solicitado de campaña:</h4>
              <p>
                {formatCurrency(listBids?.campaign?.montoSolicitado)
                  ? formatCurrency(listBids?.campaign?.montoSolicitado)
                  : '0'}
              </p>
            </div>
            <div>
              <h4>Monto total recaudado de campaña:</h4>
              <p>{formatCurrency(listBids?.campaign?.collectedAmount)}</p>
            </div>
            <div>
              <h4>Intereses de campaña al 100%:</h4>
              <p>
                {formatCurrency(listBids?.interesInversionistaPesos)
                  ? formatCurrency(listBids?.interesInversionistaPesos)
                  : '-'}
              </p>
            </div>
          </InvestInfo>
          <Recordatory>
            {showInput ? (
              <div>
                <p>Ingresa el código que enviamos a tu correo:</p>
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => {
                    setOtp(e.target.value);
                  }}
                />
                <Button size="small" onClick={handleOtpSubmit}>
                  Confirmar código
                </Button>
              </div>
            ) : (
              <div>
                <Button size="small" onClick={handleSendEmail}>
                  Aceptar
                </Button>
                <p>
                  * Recuerda que si deseas volver a invertir en esta campaña, los cálculos de los
                  intereses generados y el porcentaje del total invertido pueden variar respecto a
                  los que actualmente tienes.
                </p>
              </div>
            )}
          </Recordatory>
        </DetailInvestPay>
      </div>
    </ModalCancelInvestment>
  );
}
